import { PolotnoStoreActivePageKeys, usePolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import { useFlag } from '@/services/featureFlags';
import { Providers } from '@d-id/types';
import { observer } from 'mobx-react-lite';
import { useRef, useState } from 'react';
import { SectionContainer } from '../../common/SectionContainer';
import { SectionTitle } from '../../common/SectionTitle';
import { SimilarityControl } from '../controls/SimilarityControl';
import { StabilityControl } from '../controls/StabilityControl';
import { V3ModelControl } from '../controls/V3ModelControl';
import { VoiceModelControl } from '../controls/VoiceModelControl';

export const VoiceAdvancedSettings = observer(() => {
    const voiceConfigEnabled = useFlag('voice_configuration_enabled', false);
    const advancedSettingsSection = useRef<HTMLDivElement>(null);
    const [isAdvancedSettingsExpanded, setIsAdvancedSettingsExpanded] = useState(false);
    const [voiceConfig, setVoiceConfig] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.ttsVoiceConfig);
    const [ttsSelectedVoice, setTtsSelectedVoice] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.ttsSelectedVoice);

    const { stability, similarity_boost } = voiceConfig;

    const handleStabilityChange = (value: number) => {
        setVoiceConfig({ ...voiceConfig, stability: value });
    };

    const handleSimilarityChange = (value: number) => {
        setVoiceConfig({ ...voiceConfig, similarity_boost: value });
    };

    const handleModelChange = (value: string) => {
        setTtsSelectedVoice({ ...ttsSelectedVoice!, config: { ...ttsSelectedVoice?.config, modelId: value } });
    };

    return (
        <>
            {voiceConfigEnabled && ttsSelectedVoice?.provider === Providers.Elevenlabs && (
                <SectionContainer ref={advancedSettingsSection}>
                    <SectionTitle text="Advanced settings" show={isAdvancedSettingsExpanded} setShow={setIsAdvancedSettingsExpanded} />
                    {isAdvancedSettingsExpanded && (
                        <>
                            <V3ModelControl
                                voice={ttsSelectedVoice}
                                setValue={setTtsSelectedVoice}
                                stability={stability}
                                setStability={handleStabilityChange}
                            />
                            <StabilityControl
                                isV3Model={ttsSelectedVoice?.config?.modelId === 'eleven_v3'}
                                value={stability}
                                setValue={handleStabilityChange}
                            />
                            <SimilarityControl value={similarity_boost} setValue={handleSimilarityChange} />
                            <VoiceModelControl value={ttsSelectedVoice?.config?.modelId!} setValue={handleModelChange} />
                        </>
                    )}
                </SectionContainer>
            )}
        </>
    );
});
